import module from './module.js'
import './config.js'
import './run.js'

// Components
import './components/activacion/usuario/component.js'
import './components/excel/importar/component.js'
import './components/excel/importar/ayuda/component.js'
import './components/excel/importar/input/component.js'
import './components/excel/importar/tabla/component.js'
import './components/restablecer/modificacion/component.js'
import './components/restablecer/solicitud/component.js'
import './components/searchbox/component.js'
import './components/searchbox/lista/component.js'
import './components/searchbox/lista/item/cliente/component.js'
import './components/searchbox/lista/item/colaborador/component.js'
import './components/searchbox/lista/item/cuenta/component.js'
import './components/searchbox/lista/item/nomina/component.js'
import './components/searchbox/lista/item/movimiento/component.js'
import './components/searchbox/lista/item/proyecto/component.js'
import './components/searchbox/lista/item/servicio/component.js'
import './components/searchbox/lista/item/usuario/component.js'
import './components/sesion/component.js'
import './components/sesion/activate/component.js'
import './components/sesion/passexpired/component.js'
import './components/sesion/passhelp/component.js'
import './components/table/component.js'
import './components/table/cell/directive.js'
import './components/table/column/component.js'
import './components/table/columns/component.js'
import './components/table/header/component.js'
import './components/table/headers/component.js'
import './components/table/row/component.js'
import './components/ui/document/component.js'

// Directives
import './directives/app-backspace-navigation-disabled/directive.js'
import './directives/app-contextmenu-disabled/directive.js'
import './directives/app-edgemode/directive.js'

// Routes
import './routes/activacion.js'
import './routes/activacion/usuario.js'
import './routes/restablecer.js'
import './routes/restablecer/password.js'
import './routes/restablecer/solicitar.js'
import './routes/sesion.js'
import './routes/sesion/activate.js'
import './routes/sesion/pass_expired.js'

// Services
import './services/$catalogos.js'
import './services/Activacion/Token.js'
import './services/Activacion/Usuario.js'
import './services/AppBreadcrumbs.js'
import './services/Restablecer.js'
import './services/Restablecer/Token.js'

export default module.name



// WEBPACK FOOTER //
// ./src/app/index.js